import {findSupplierComputedProductByLinkProduct} from './findSupplierComputedProductByLinkProduct';

export default {
    findSupplierComputedProductByLinkProduct
}